import Axios from 'axios';

const http = Axios.create({
  withCredentials: true,
});

// Set the base URL depending on the environment.
let baseURL = '';

switch (true) {
  case window.location.hostname.includes('.local'):
    baseURL = process.env.VUE_APP_BASE_URL;
    break;
  case process.env.NODE_ENV === 'development':
    baseURL = '';
    break;
  default:
    baseURL = process.env.VUE_APP_BASE_URL_PROD || '';
    break;
}

// If the token exists add it to the axios instance.
const token = localStorage.getItem('token');

if (token) {
  http.defaults.headers.common.Authorization = `Bearer ${token}`;
}

// Get the CSRF token and set the base URL.
http.get(`${baseURL}/sanctum/csrf-cookie`);
http.defaults.baseURL = `${baseURL}/api`;

// If the token expires we need to refresh it.
http.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      this.$store.dispatch('logout');
    }

    return Promise.reject(error);
  },
);

export { http };

export default async function HttpPlugin(Vue) {
  Vue.prototype.$http = http;
}
